<template>
  <g>
    <path
      d="M5.25 14.248C7.735 14.248 9.75 16.263 9.75 18.748C9.75 21.233 7.735 23.248 5.25 23.248C2.765 23.248 0.75 21.233 0.75 18.748C0.75 16.263 2.765 14.248 5.25 14.248Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.75 14.248C21.235 14.248 23.25 16.263 23.25 18.748C23.25 21.233 21.235 23.248 18.75 23.248C16.265 23.248 14.25 21.233 14.25 18.748C14.25 16.263 16.265 14.248 18.75 14.248Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 0.747986C14.485 0.747986 16.5 2.76299 16.5 5.24799C16.5 7.73299 14.485 9.74799 12 9.74799C9.515 9.74799 7.5 7.73299 7.5 5.24799C7.5 2.76299 9.515 0.747986 12 0.747986Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.738 14.724L14.012 9.27298"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 18.748H14.25"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.98802 9.27298L7.26202 14.724"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
export default {
  name: "IconBehavior",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {},
};
</script>
